import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import { tinaField } from "tinacms/tina-field";

import { client } from "../tina/__generated__/client";

import * as Lucide from "lucide-react";

export { useTina } from "./use-tina";

export const tinaClient = client;
export { tinaField };

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const DEFAULT_SEO = {
  siteName: "Aberrant",
  title: "Aberrant",
  description:
    "Aberrant's Information Security Management Platform (ISM-P) is designed to be a service neutral system of record for your cybersecurity program.",
  keywords:
    "ISM-P, Information Security Management Platform, NIST Privacy, GDPR, CCPA, Security Compliance, Security Program, SSAE 18 SOC 2, ISO 27001, ISO 27701, CMMC, CIS V8 Controls, 201 CMR 17.00, HITRUST, ISMS, Compliance Software, GRC",
  image:
    "https://res.cloudinary.com/di91tjdw2/image/upload/v1751307123/Aberrant_Logo_gm52r3.png",
};

export function formatMetadata({ seo = {}, pagePath = "/" }) {
  try {
    const canonicalUrl = pagePath;

    return {
      title: seo.title ? `${seo.title} | Aberrant` : DEFAULT_SEO.title,
      description: seo.description || DEFAULT_SEO.description,
      keywords: seo.keywords || DEFAULT_SEO.keywords,
      alternates: {
        canonical: canonicalUrl,
      },
      openGraph: {
        type: "website",
        siteName: DEFAULT_SEO.siteName,
        title: seo.title ? `${seo.title} | Aberrant` : DEFAULT_SEO.title,
        description: seo.description || DEFAULT_SEO.description,
        url: `https://aberrant.io${canonicalUrl}`,
        images: [
          {
            url: seo.image || DEFAULT_SEO.image,
            width: 1600,
            height: 900,
            alt: DEFAULT_SEO.siteName,
          },
        ],
      },
    };
  } catch (error) {
    console.error(`Error formatting metadata:`, error);
    return DEFAULT_SEO;
  }
}

export function coloredText(text) {
  if (!text?.children?.[0]?.children) {
    return text?.text || "";
  }

  return text.children[0].children
    .map((child) => {
      if (child.bold) {
        return `<span class="text-primary-300">${child.text}</span>`;
      }
      return child.text;
    })
    .join("");
}

export function getIcon(iconString) {
  if (!iconString) {
    return null;
  }

  const iconName = iconString
    ?.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
    .replace(/^[a-z]/, (letter) => letter.toUpperCase());
  const Icon = Lucide?.[iconName] || null;

  return Icon;
}
